import React, { useEffect, useRef, useState } from 'react';
import css from './ListAdmin.module.scss';
import { NavLink } from "react-router-dom";
import ATable from '../../../Components/ATable/ATable';
import { getDataListAdmin } from '../../../Services/Admin/ListAdminServices';
import SettingTable from '../../../Components/ATable/SettingTable';

const ListAdminPage = () => {
    const role_code = localStorage.getItem("role_code_admin");

    // alert(role_code)
    let columns = [
        {title: "No", field: "no", align: "center", sortable: true},
        {title: "Username", field: "username", align: "left", sortable: true},
        {title: "Email", field: "email", align: "left", sortable: true},
        {title: "Status", field: "is_active", align: "left", sortable: true, boolean: true },
        {
            title: "Action", 
            field: "action", 
            align: "center", 
            sortable: true, 
            type:'action', 
            link: '/admin/list-admin/edit-admin',
            value: <i class="fi fi-rr-edit"></i>,
            primary :'username',
            admin: false,   
        }
    ];

    const settingTable = {
        admin:role_code =='Super' ? false : true,
        FilterSearchAll : true,
        CreateButtonWithLink : role_code =='Super' ? '/admin/list-admin/add-admin' : false,
        filter:true,  
    };
    



    return (
        <div className='wrap_admin'>
            <div className='row vh-100'>
                <div className='col-md-12' style={{ maxHeight: '100vh', overflowY: 'auto', overflowX: 'hidden' }}>

                    <div className={`${css.content_position} row`} style={{ marginBottom: 100 }}>
                        <SettingTable columns={columns} data={getDataListAdmin} {...settingTable} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ListAdminPage;
